import React, { lazy } from 'react'
import { RiUserSettingsLine } from "react-icons/ri";
import lazyComponent from './lazy'
import { TbUserX } from 'react-icons/tb'
import { TbUser } from 'react-icons/tb'
import { VscWorkspaceTrusted } from "react-icons/vsc";
// components
import RUView from 'containers/Admin/Users';
import Roles from 'containers/Admin/Roles';

const Component: React.FC = () => <div>Testing</div>

const RU = [
  {
    key: 'view_Ad',
    url: 'admin',
    name: 'App.Ad',
    roles: ['IMOX'],
    title: 'Administración',
    redirectTo: 'App.Ad.Users',
    data: {
      nav: {
        type: 'menu',
        sort: Number.MAX_SAFE_INTEGER - 1,
        icon: <RiUserSettingsLine />
      }
    }
  },
  {
    key: 'view_Ad_Users',
    url: '/users',
    roles: ['IMOX'],
    name: 'App.Ad.Users',
    title: 'Usuarios',
    views: {
      'main@App': { component: lazyComponent(RUView) }
    },
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <TbUser />
      }
    }
  },
  {
    key: 'view_Ad_Roles',
    url: '/roles',
    roles: ['IMOX'],
    name: 'App.Ad.Roles',
    title: 'Roles',
    views: {
      'main@App': { component: lazyComponent(Roles) }
    },
    data: {
      nav: {
        type: 'menu',
        sort: 2,
        icon: <VscWorkspaceTrusted />
      }
    }
  },
]

export default RU
